import { Box, CircularProgress } from '@mui/material';
import React, { ReactElement } from 'react';

export type CardTitleWithSpinnerAndChipProps = {
  isWaiting?: boolean;
  statusChip?: ReactElement;
  title: string;
};

const CardTitleWithSpinnerAndChip = ({ title, isWaiting, statusChip }: CardTitleWithSpinnerAndChipProps) => {
  return (
    <Box alignItems="center" display="flex">
      <span className="font-2xl">{title}</span>
      {isWaiting ? (
        <CircularProgress sx={{ ml: '14px' }} size="1.25rem" />
      ) : statusChip ? (
        <Box
          display="inline-block"
          ml="8px"
          height="20px"
          fontSize="18px"
          sx={{ '.MuiChip-root': { verticalAlign: 'top' } }}
        >
          {statusChip}
        </Box>
      ) : null}
    </Box>
  );
};

export { CardTitleWithSpinnerAndChip };
